import React, { useState, useEffect, useRef, useCallback } from "react";
import axios from "axios";
import '@fortawesome/fontawesome-free/css/all.min.css';
import backgroundImage from '../assets/backgorund/home2.jpg';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;

const uploadConfig = {
  committee: {
    placeholder: "Enter Committee Member Name",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  board: {
    placeholder: "Enter Board Member Name",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  state: {
    placeholder: "Enter State Awards Name",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  national: {
    placeholder: "Enter National Awards Name",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  international: {
    placeholder: "Enter International Awards Name",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  monthly_newsletter: {
    placeholder: "ex. January 2024",
    label: "Upload only PDF file",
    accept: "application/pdf",
  },
  Legal_documents: {
    placeholder: "Enter Legal documents Title",
    label: "Upload only PDF file",
    accept: "application/pdf",
  },
  Company_brochure: {
    placeholder: "ex. English / Marathi / Hindi",
    label: "Upload only PDF file",
    accept: "application/pdf",
  },
  Annual_reports: {
    placeholder: "ex. 2024 / 2025 / 2026",
    label: "Upload only PDF file",
    accept: "application/pdf",
  },
  friends: {
    placeholder: "Enter Name",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  photos: {
    placeholder: "Enter Title",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  VIP: {
    placeholder: "Enter Title",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  media: {
    placeholder: "Enter Title",
    label: "Upload only JPEG/PNG file",
    accept: "image/jpeg,image/png",
  },
  videos: {
    placeholder: "Enter Video Title",
    label: "Enter YouTube Embedded URL",
  },
  "media-link": {
    placeholder: "Enter Media Title",
    label: "Add Media URL",
  },
};

const UploadPage = ({ section: type }) => {  
  const [title, setTitle] = useState("");
  const [file, setFile] = useState(null);
  const [subType, setSubType] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [documents, setDocuments] = useState([]);
  const [link, setLink] = useState("");
  const fileInputRef = useRef(null);

  const subTypesMap = {
    about: ["committee", "board"],
    awards: ["state", "national", "international"],
    documents: ["monthly_newsletter", "Legal_documents", "Company_brochure", "Annual_reports"],
    friends: ["friends"],
    gallery: ["VIP", "photos", "videos", "media", "media-link"],
  };

  const capitalize = (text) =>
    text.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  const fetchDocuments = useCallback(async (subTypeParam) => {
    try {
      const url = `${apiBaseUrl}/documents?type=${type}` + (subTypeParam ? `&subType=${subTypeParam}` : "");
      const res = await axios.get(url);
      setDocuments(res.data);
    } catch (err) {
      console.error("Error fetching documents");
    }
  }, [type]);

  useEffect(() => {
    fetchDocuments(subType);
  }, [fetchDocuments, subType]);

  const handleUpload = async () => {
    // Clear previous errors and messages
    setError("");
    setMessage("");

    if (!subType) {
      setError("Please select a category.");
      return;
    }

    if (!title.trim()) {
      setError("Please enter a title.");
      return;
    }

    if (subType !== "videos" && subType !== "media-link" && !file) {
      setError("Please select a file to upload.");
      return;
    }

    if ((subType === "videos" || subType === "media-link") && !link.trim()) {
      setError("Please enter a valid URL.");
      return;
    }

    const formData = new FormData();
    formData.append("title", title);
    formData.append("type", type);
    formData.append("subType", subType);

    if (subType === "videos" || subType === "media-link") {
      formData.append("path", link);
    } else {
      formData.append("file", file);
    }

    try {
      await axios.post(`${apiBaseUrl}/documents`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setMessage("✅ Uploaded successfully.");
      setTitle("");
      setFile(null);
      setLink("");
      if (fileInputRef.current) fileInputRef.current.value = "";
      fetchDocuments(subType);
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      console.error("Upload error:", err);
      setMessage("❌ Upload failed. " + (err.response?.data?.message || ""));
      setTimeout(() => setMessage(""), 3000);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this document?")) return;
    try {
      await axios.delete(`${apiBaseUrl}/documents/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      fetchDocuments(subType);
      setMessage("✅ Document deleted successfully.");
      setTimeout(() => setMessage(""), 3000);
    } catch (err) {
      setMessage("❌ Delete failed. " + (err.response?.data?.message || ""));
      setTimeout(() => setMessage(""), 3000);
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", minHeight: "80vh", textAlign: "center", backgroundImage: `url(${backgroundImage})` }}>
      {/* Navigation */}
      <div style={{
        color: "black",
        padding: "1px 1px",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center"
      }}>
        <h2 style={{ margin: 5, fontSize: "30px", flex: 1 }}>Admin Panel</h2>
      </div>

      <hr style={{
        border: "none",
        height: "2px",
        backgroundColor: "#ccc",
        margin: "10px 0",
        width: "100%"
      }} />

      {/* Upload + Table */}
      <div style={{ display: "flex", padding: "20px", gap: "20px", flex: 1 }}>
        {/* Upload Form */}
        <div style={{ flex: 1 }}>
          <h3>Upload To {(type || "unknown").toUpperCase()} Section</h3>

          {subTypesMap[type] ? (
            <>
              {subTypesMap[type].map((st) => (
                <button
                  key={st}
                  onClick={() => {
                    setSubType(st);
                    fetchDocuments(st);
                    setError("");
                    setMessage("");
                  }}
                  style={{
                    margin: "10px",
                    padding: "12px 20px",
                    backgroundColor: subType === st ? "#1e40af" : "#3b82f6",
                    color: "white",
                    border: "none",
                    borderRadius: "3px",
                    cursor: "pointer",
                  }}
                >
                  {st === "committee" ? "Add Advisory Committee Of Snehwan" : 
                   st === "board" ? "Add Board Of Director-Snehwan" : 
                   `Add ${capitalize(st)}`}
                </button>
              ))}

              {subType && (
                <div style={{ marginTop: "20px", display: "flex", flexDirection: "column", alignItems: "center", gap: "10px" }}>
                  {/* Title Input */}
                  <input
                    type="text"
                    placeholder={uploadConfig[subType]?.placeholder || "Title"}
                    value={title}
                    onChange={(e) => setTitle(e.target.value)}
                    style={{ width: "50%", padding: "8px" }}
                  />

                  {/* File or Link Input */}
                  {subType === "videos" || subType === "media-link" ? (
                    <input
                      type="text"
                      placeholder={uploadConfig[subType].label}
                      value={link}
                      onChange={(e) => setLink(e.target.value)}
                      style={{ width: "50%", padding: "8px" }}
                    />
                  ) : (
                    <>
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={(e) => {
                          setFile(e.target.files[0]);
                          setError("");
                        }}
                        style={{ width: "50%" }}
                        accept={uploadConfig[subType]?.accept}
                      />
                      <small style={{ fontStyle: "italic", color: "#555" }}>
                        {uploadConfig[subType]?.label}
                      </small>
                    </>
                  )}

                  {/* Error message display */}
                  {error && (
                    <div style={{ color: "red", margin: "5px 0", fontWeight: "bold" }}>
                      {error}
                    </div>
                  )}

                  <button
                    onClick={handleUpload}
                    style={{
                      backgroundColor: "#059669",
                      color: "white",
                      padding: "10px 20px",
                      border: "none",
                      borderRadius: "5px",
                      cursor: "pointer",
                      fontSize: "16px",
                      marginTop: "10px"
                    }}
                  >
                    Upload 
                  </button>

                  {message && (
                    <div style={{
                      margin: "10px 0",
                      padding: "10px",
                      backgroundColor: message.includes("✅") ? "#d1fae5" : "#fee2e2",
                      color: message.includes("✅") ? "#065f46" : "#b91c1c",
                      borderRadius: "5px",
                      fontWeight: "bold"
                    }}>
                      {message}
                    </div>
                  )}
                </div>
              )}
            </>
          ) : (
            <p style={{ color: "red" }}>Invalid section: {type}</p>
          )}
        </div>

        {/* Table Section */}
        <div style={{ flex: 1 }}>
          <h3 style={{ fontSize: "18px", fontWeight: "bold", marginBottom: "10px" }}>
            Uploaded Documents {subType ? `– ${capitalize(subType)}` : ""}
          </h3>
          <div style={{ maxHeight: "500px", overflowY: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse", textAlign: "center" }}>
              <thead>
                <tr>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>ID</th>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>Title</th>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>Type</th>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>Document</th>
                  <th style={{ borderBottom: "1px solid #ccc", padding: "8px" }}>Action</th>
                </tr>
              </thead>
              <tbody>
                {documents.map((doc) => (
                  <tr key={doc.id}>
                    <td style={{ padding: "6px" }}>{doc.id}</td>
                    <td style={{ padding: "6px" }}>{doc.title}</td>
                    <td style={{ padding: "6px" }}>{doc.subType}</td>
                    <td style={{ padding: "6px" }}>
                      <a
                        href={doc.path.startsWith("http") ? doc.path : `${process.env.REACT_APP_BASE_URL}${doc.path}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ color: "#2563eb", textDecoration: "underline" }}
                      >
                        View
                      </a>
                    </td>
                    <td style={{ padding: "4px" }}>
                      <button
                        onClick={() => handleDelete(doc.id)}
                        style={{
                          padding: "5px 10px",
                          fontSize: "14px",
                          borderRadius: "4px",
                          backgroundColor: "#ef4444",
                          color: "white",
                          border: "none",
                          cursor: "pointer",
                        }}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))}
                {documents.length === 0 && (
                  <tr>
                    <td colSpan="5" style={{ textAlign: "center", padding: "10px" }}>
                      No documents uploaded yet.
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UploadPage;